var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mint",
    transform: "translate(-350.000000, -170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-32",
    transform: "translate(350.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#007AF0",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.991856,13.2366948 C13.8249475,12.9671544 13.3935845,12.8988596 13.1929997,13.0757348 C11.1857855,14.8190345 10,17.3427984 10,19.9977109 C10,22.6151279 11.1546257,25.1040785 13.13973,26.9910081 C13.4158927,27.235857 13.8144064,27.1839989 13.9868754,26.889576 L18.0041615,20.3039152 C18.1053544,20.1437031 18.1053544,19.9744639 17.9924934,19.795455 L13.991856,13.2366948 Z M26.8367887,12.9781798 C26.5815445,12.7680418 26.1826875,12.8320796 26.0131246,13.1058459 L21.9958385,19.6915066 C21.8946456,19.8517187 21.8946456,20.020958 22.0075066,20.1999669 L26.0131246,26.7668308 L26.0265515,26.7893087 C26.199277,27.084651 26.4799047,27.1221974 26.7247246,26.8741288 L26.8070003,26.7969419 C28.8142145,25.0536422 30,22.5298784 30,19.8749658 C30,17.2200532 28.8142145,14.6962894 26.8367887,12.9781798 Z M20.037,22.6584017 L16.5939672,28.3037629 C15.4720503,30.2221207 12.7756291,30.5730028 11.05899,29.0498521 C8.48837738,26.607923 7,23.3995259 7,19.9977109 C7,16.5332354 8.54529846,13.244303 11.1636359,10.97029 C12.7805728,9.54401001 15.4503334,9.96669563 16.5805403,11.7919261 L19.962,17.3362379 L23.4244403,11.6610772 C24.512776,9.90352507 26.9673674,9.46146814 28.6704349,10.7173511 L28.8278311,10.8400762 C31.4547015,13.1215579 33,16.4104903 33,19.8749658 C33,23.3394413 31.4547015,26.6283737 28.8278311,28.9098554 L28.859,28.8810927 L28.7659379,28.9712309 C27.1531379,30.4407873 24.6733171,30.1112193 23.5082641,28.3454854 L23.415,28.1959297 L20.037,22.6584017 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(20.000000, 20.000000) rotate(-60.000000) translate(-20.000000, -20.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlpIcon);
export default __webpack_public_path__ + "static/media/alp-icon.c27ee38904d20cceef3a81405f534f18.svg";
export { ForwardRef as ReactComponent };